import React from 'react'
import { TableRowField } from '../../../../components'
import { formatHelper } from '../../../../common/helpers'



export function productDetailXS(columnOption) {
    return ([
        {
            dataField: 'xs',
            text: 'Cliente',
            formatter: (cell, row) => {
                return (
                    <div>
                        <TableRowField label='Tienda:' value={row.Store.name} />
                        <TableRowField label='Stock Mínimo:' value={row.minStock} />
                        <TableRowField label='Stock Actual:' value={row.quantity} />
                    </div>
                )
            }
        },
        columnOption
    ])
}

export function productDetailSM(columnOption) {
    return ([
        {
            dataField: 'sm',
            text: 'Tienda',
            formatter: (cell, row) => {
                return (
                    <div>
                        <TableRowField label='Tienda:' value={row.Store.name} />
                        <TableRowField label='Stock Mínimo:' value={row.minStock} />
                    </div>
                )
            }
        },
        {
            dataField: 'quantity',
            text: 'Stock Actual'
        },
        columnOption
    ])
}

export function productDetail(columnOption) {
    return ([
        {
            dataField: 'Store.name',
            text: 'Tienda'
        },
        {
            dataField: 'minStock',
            text: 'Stock Mínimo'
        },
        {
            dataField: 'quantity',
            text: 'Stock Actual',
        },
        columnOption
    ])
}


// WEBPACK FOOTER //
// ./src/scenes/Administration/Product/ProductDetail/_columns.js